module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foo",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._l((_vm.notifications), function(item) {
    return (_vm.showNotification) ? _c('div', [_c('a', {
      staticStyle: {
        "font-size": "20px"
      },
      attrs: {
        "href": item.text,
        "hidden": !_vm.isLink(item.text)
      }
    }, [_c('u', [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('p', {
      style: (_vm.getStyle(item)),
      attrs: {
        "hidden": !_vm.isSimpleText(item.text)
      }
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('button', {
      staticClass: "button button-outline",
      attrs: {
        "hidden": !_vm.isButton(item.text)
      },
      on: {
        "click": function($event) {
          return _vm.onButtonClicked(item.text)
        }
      }
    }, [_vm._v(_vm._s(_vm.getButtonText(item.text)))]), _vm._v(" "), _c('span', [(_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('button', {
      staticClass: "button button-outline",
      on: {
        "click": function($event) {
          return _vm.deleteNotification(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    })]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "center text-center"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('hr'), _vm._v(" "), _c('a', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        return _vm.openTerms()
      }
    }
  }, [_vm._v("Izjava i pravilnik kluba CrossFit NS ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "30%",
      "height": "80%"
    },
    attrs: {
      "src": require("../../assets/img/cfns_logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center text-center"
  }, [_c('p', [_vm._v("Danila Kiša 3, Novi Sad")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center text-center"
  }, [_c('a', [_vm._v("(+381)21/6622387")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center text-center"
  }, [_c('a', [_vm._v("(+381)64/6428965")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center text-center"
  }, [_c('p', [_vm._v("infocfns@gmail.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10%"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/crossfit_ns"
    }
  }, [_c('img', {
    attrs: {
      "width": "56px",
      "height": "56px",
      "src": require("../../assets/img/instagram.png")
    }
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5%",
      "margin-right": "10%"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://journal.crossfit.com/"
    }
  }, [_c('img', {
    attrs: {
      "width": "80px",
      "height": "56px",
      "src": require("../../assets/img/cfns-journal.png")
    }
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://m.facebook.com/crossfitns"
    }
  }, [_c('img', {
    attrs: {
      "width": "56px",
      "height": "56px",
      "src": require("../../assets/img/ic_facebook.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b32b2b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 802
// module chunks = 0